var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOnMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5859375,2c-0.6357422,0-1.2578125,0.2578125-1.7070312,0.7070312L12.5859375,14H3c-1.6542969,0-3,1.3457031-3,3v14 c0,1.6542969,1.3457031,3,3,3h9.5859375l11.2929688,11.2929688C24.328125,45.7421875,24.9501953,46,25.5859375,46 C26.9169922,46,28,44.9169922,28,43.5859375V4.4140625C28,3.0830078,26.9169922,2,25.5859375,2z M26,43.5859375 c0,0.3378906-0.46875,0.53125-0.7070312,0.2929688L13.7070312,32.2929688C13.5195312,32.1054688,13.265625,32,13,32H3 c-0.5517578,0-1-0.4482422-1-1V17c0-0.5517578,0.4482422-1,1-1h10c0.265625,0,0.5195312-0.1054688,0.7070312-0.2929688 L25.2929688,4.1210938C25.53125,3.8828125,26,4.0761719,26,4.4140625V43.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0712891,16.9287109c0.251709,0.2518311,0.4857788,0.5162964,0.7069092,0.7891235 C36.2161255,19.4920044,37,21.6850586,37,24s-0.7838745,4.5079956-2.2218018,6.2821655 c-0.2211304,0.2728271-0.4552002,0.5372925-0.7069092,0.7891235l1.4140625,1.4140625C37.7519531,30.2177734,39,27.2041016,39,24 s-1.2480469-6.2177734-3.5146484-8.4853516L34.0712891,16.9287109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8496094,9.1503906l-1.4140625,1.4140625C44.0234375,14.1533203,46,18.9248047,46,24 s-1.9765625,9.8466797-5.5644531,13.4355469l1.4140625,1.4140625C45.8154297,34.8837891,48,29.6103516,48,24 S45.8154297,13.1162109,41.8496094,9.1503906z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOnMedium);
export default __webpack_public_path__ + "static/media/volume-on--medium.cad37d42b6e1c0857b0955f0887072ef.svg";
export { ForwardRef as ReactComponent };